// extracted by mini-css-extract-plugin
export var newsEntryWrapper = "newsEntryListingPage-module--newsEntryWrapper--58dee";